import {Model} from "vue-mc";

export class User extends Model
{
    defaults() {
        return {
            id: null,
            name: '',
            surname: '',
            email: '',
            password: '',
        }
    }
}
